<input
  [disabled]="disabled"
  accept="{{ accept }}"
  type="file"
  class="form-control"
  multiple
  id="{{ id }}"
  (change)="onFilesSelected($event)"
/>
